import type { ArtifactResourceReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { ArtifactComponentTypeEnum, ArtifactResource, ArtifactTypeEnum } from '../../models/artifact.model';

export function mapUploadedApplicationFile({
  checksum,
  id,
  mimeType,
  fileName: name,
  size,
  type,
  componentType,
}: ArtifactResourceReadV2Api): ArtifactResource {
  return {
    checksum,
    id,
    mimeType,
    name,
    size,
    type: type as ArtifactTypeEnum,
    componentType: componentType as ArtifactComponentTypeEnum,
  };
}
